// import './WareHouseList.scss';
// import { useEffect, useState, useCallback } from 'react';
// import { BASE_URL } from '../../../api/constants';
// import requestInstance from '../../../services/AuthService/AccessTokenUpdateService';
// import { Pagination } from '../../../components/Pagination/Pagination';
// import { toast, ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import deleteImg from './images/delete.png';
// import editImg from './images/edit.png';
// import { Link } from 'react-router-dom';
// import facebookImg from './images/facebook.png';
// import instagramImg from './images/instagram.png';
// import youTubeImg from './images/youtobe.png';

// export const BrandList = ({ setCurrentForm, setCurrentProduct }) => {
//   const [currentCategory, setCurrentCategory] = useState('');
//   const [wareHouses, setWareHouse] = useState([]);
//   const [category, setCategory] = useState([]);
//   const [nextPage, setNextPage] = useState(null);
//   const [prevPage, setPrevPage] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [count, setCount] = useState(0);
//   const [totalPages, setTotalPages] = useState(0);
//   const itemsPerPage = 5;
//   const company_id = JSON.parse(localStorage.getItem('user')).company.id;

//   const getData = useCallback(async (offset = 0, category = '') => {
//     try {
//       // const categoryFilter = category ? `&type_of_ware_house_id=${category}` : '';
//       const wareHousesUrl = `${BASE_URL}ware-houses/?company_id=${company_id}&limit=${itemsPerPage}&offset=${offset}`;
//       // const categoriesUrl = `${BASE_URL}ware-houses/type/?company_id=${company_id}`;

//       const [wareHousesResponse, categoriesResponse] = await Promise.all([
//         requestInstance.get(wareHousesUrl),
//         // requestInstance.get(categoriesUrl)
//       ]);

//       setWareHouse(wareHousesResponse.data.results);
//       setNextPage(wareHousesResponse.data.next);
//       setPrevPage(wareHousesResponse.data.previous);
//       setTotalPages(Math.ceil(wareHousesResponse.data.count / itemsPerPage));
//       setCount(wareHousesResponse.data.count);

//       setCategory(categoriesResponse.data.results);
//     } catch (error) {
//       console.error(error);
//       toast.error('Failed to fetch products or categories');
//     }
//   }, [company_id, itemsPerPage]);

//   useEffect(() => {
//     const offset = (currentPage - 1) * itemsPerPage;
//     getData(offset, currentCategory);
//   }, [getData, currentPage, currentCategory]);

//   const handleCategoryChange = (e) => {
//     const selectedCategory = e.target.value;
//     setCurrentCategory(selectedCategory);
//     setCurrentPage(1); 
//   };

//   const mainPhoto = (item) => item.ware_house_image?.find(img => img.main)?.image;

//   const handleDeleteWareHouse = async (wareHouseId) => {
//     if (window.confirm('Are you sure you want to delete this ware house?')) {
//       try {
//         await requestInstance.delete(`${BASE_URL}ware-houses/${wareHouseId}/`);
//         setWareHouse(wareHouses.filter(wareHouse => wareHouse.id !== wareHouseId));
//         toast.success('Ware Houses deleted successfully');
//       } catch (error) {
//         console.error(error);
//         toast.error('Failed to delete ware houses');
//       }
//     }
//   };
//   const truncateString = (str, num) => {
//     if (str.length <= num) {
//       return str;
//     }
//     return str.slice(0, num) + '...';
//   };
//   return (
//     <div className='ProductsList'>
//       <ToastContainer />
//       <div className='ProductsList__header'>
//         <div className='ProductsList__top'>
//           <h2 className='ProductsList__title'>My Brands ({count})</h2>
//           <button
//             onClick={() => {
//               setCurrentForm('brandForm');
//               setCurrentProduct(null);
//             }} className='ProductsList__add-button' style={{width: '150px'}}>+ Create brand</button>
//         </div>
//         {/* <div className='ProductsList__category_container'>
//           <h3 className='ProductsList__category_title'>Category:</h3>
//           <select
//             className='ProductsList__category_select'
//             value={currentCategory}
//             onChange={handleCategoryChange}
//           >
//             <option value=''>All</option>
//             {category.map((cat) => (
//               <option value={cat.id} key={cat.id}>{cat.name}</option>
//             ))}
//           </select>
//         </div> */}
//       </div>

//       <table className='ProductsList__table'>
//         <thead className='ProductsList__table_name'>
//           <tr>
//             <th className='ProductsList__table-header'>Brand</th>
//             <th className='ProductsList__table-header'>Brandname</th>
//             <th className='ProductsList__table-header'>Social media</th>
//             <th className='ProductsList__table-header'style={{width:'80px'}}></th>
//           </tr>
//         </thead>
//         <tbody>
//           {wareHouses.map((wareHouse) => {
//             console.log(wareHouse); 
//             return (
//               <tr key={wareHouse.id}>
//                 <td className='ProductsList__product ProductsList__row_item'>
//                 <Link to={`../ware-house/${wareHouse.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
//                   <img src={mainPhoto(wareHouse)} alt={wareHouse.name} className='ProductsList__product-image' />
//                  </Link>  
                
//                 </td>
//                 <td className='ProductsList__row_item'><Link to={`../ware-house/${wareHouse.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
//                   <p>{wareHouse.name}</p>
//                 </Link>  
//                 </td> 
//                 <td className='ProductsList__row_item'>
//                 {wareHouse.facebook_url && <a href={wareHouse.facebook_url}><img src={facebookImg } alt='facebook' /></a>}
//           {wareHouse.instagram_url && <a href={wareHouse.instagram_url}><img src={instagramImg} alt='instagram' /></a>}
//           {wareHouse.you_tube_url && <a href={wareHouse.you_tube_url }><img src={youTubeImg} alt='youTube' /></a>}
//                 </td> 
               
//                 <td className='ProductsList__row_item'>
//                   <img className='ProductsList__icon' src={deleteImg} alt="delete" onClick={() => handleDeleteWareHouse(wareHouse.id)} />
//                   <img className='ProductsList__icon' src={editImg} alt="edit" onClick={() => {
//                     setCurrentForm('brandForm');
//                     setCurrentProduct(wareHouse.id);
//                   }}/>
//                   </td>
//                 </tr>
//             );
//           })}
//         </tbody>
//       </table>

//       <Pagination
//         itemsPerPage={itemsPerPage}
//         setObjects={setWareHouse}
//         setNextPage={setNextPage}
//         setPrevPage={setPrevPage}
//         nextPage={nextPage}
//         prevPage={prevPage}
//         currentPage={currentPage}
//         totalPages={totalPages}
//         setCurrentPage={setCurrentPage}
//         count={count}
//       />
//     </div>
//   );
// };

// export default BrandList;

import './WareHouseList.scss';
import { useEffect, useState, useCallback } from 'react';
import { BASE_URL } from '../../../api/constants';
import requestInstance from '../../../services/AuthService/AccessTokenUpdateService';
import { Pagination } from '../../../components/Pagination/Pagination';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import deleteImg from './images/delete.png';
import editImg from './images/edit.png';
import { Link } from 'react-router-dom';
import facebookImg from './images/facebook.png';
import instagramImg from './images/instagram.png';
import youTubeImg from './images/youtobe.png';

export const BrandList = ({ setCurrentForm, setCurrentProduct }) => {
  const [brands, setBrands] = useState([]);
  const [nextPage, setNextPage] = useState(null);
  const [prevPage, setPrevPage] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [count, setCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const itemsPerPage = 5;
  const company_id = JSON.parse(localStorage.getItem('user')).company.id;

  const getData = useCallback(async (offset = 0) => {
    try {
      const brandsUrl = `${BASE_URL}ware-houses/?company_id=${company_id}&limit=${itemsPerPage}&offset=${offset}`;

      const response = await requestInstance.get(brandsUrl);

      setBrands(response.data.results);
      setNextPage(response.data.next);
      setPrevPage(response.data.previous);
      setTotalPages(Math.ceil(response.data.count / itemsPerPage));
      setCount(response.data.count);
    } catch (error) {
      console.error(error);
      toast.error('Failed to fetch brands');
    }
  }, [company_id, itemsPerPage]);

  useEffect(() => {
    const offset = (currentPage - 1) * itemsPerPage;
    getData(offset);
  }, [getData, currentPage]);

  const handleDeleteBrand = async (brandId) => {
    if (window.confirm('Are you sure you want to delete this brand?')) {
      try {
        await requestInstance.delete(`${BASE_URL}ware-houses/${brandId}/`);
        setBrands(brands.filter((brand) => brand.id !== brandId));
        toast.success('Brand deleted successfully');
      } catch (error) {
        console.error(error);
        toast.error('Failed to delete brand');
      }
    }
  };

  const truncateString = (str, num) => (str?.length > num ? `${str.slice(0, num)}...` : str || '');

  const renderSocialLinks = (brand) => {
    const socialMedia = [
      { url: brand.facebook_url, img: facebookImg, alt: 'Facebook' },
      { url: brand.instagram_url, img: instagramImg, alt: 'Instagram' },
      { url: brand.you_tube_url, img: youTubeImg, alt: 'YouTube' },
    ];

    return socialMedia
      .filter(({ url }) => url)
      .map(({ url, img, alt }, index) => (
        <a key={index} href={url} target="_blank" rel="noopener noreferrer">
          <img src={img} alt={alt} />
        </a>
      ));
  };

  return (
    <div className='ProductsList'>
      <ToastContainer />
      <div className='ProductsList__header'>
        <div className='ProductsList__top'>
          <h2 className='ProductsList__title'>My Brands ({count})</h2>
          <button
            onClick={() => {
              setCurrentForm('brandForm');
              setCurrentProduct(null);
            }}
            className='ProductsList__add-button'
            style={{ width: '150px' }}
          >
            + Create brand
          </button>
        </div>
      </div>

      <table className='ProductsList__table'>
        <thead className='ProductsList__table_name'>
          <tr>
            <th className='ProductsList__table-header'>Brand</th>
            <th className='ProductsList__table-header'>Brand Name</th>
            <th className='ProductsList__table-header'>Social Media</th>
            <th className='ProductsList__table-header' style={{ width: '80px' }}></th>
          </tr>
        </thead>
        <tbody>
          {brands.map((brand) => (
            <tr key={brand.id}>
              <td className='ProductsList__product ProductsList__row_item'>
                <Link to={`../ware-house/${brand.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                  <img src={brand.ware_house_image?.[0]?.image} alt={brand.name} className='ProductsList__product-image' />
                </Link>
              </td>
              <td className='ProductsList__row_item'>
                <Link to={`../ware-house/${brand.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                  <p>{brand.name}</p>
                </Link>
              </td>
              <td className='ProductsList__row_item'>          {brand.facebook_url && <a href={brand.facebook_url}><img src={facebookImg } alt='facebook' /></a>}
          {brand.instagram_url && <a href={brand.instagram_url}><img src={instagramImg} alt='instagram'  style={{
        width: '24px', // Adjust size
                  height: '24px',
        paddingBottom: '12px'
      }}/></a>}
          {brand.you_tube_url && <a href={brand.you_tube_url }><img src={youTubeImg} alt='youTube' /></a>}</td>
              <td className='ProductsList__row_item'>
                <img className='ProductsList__icon' src={deleteImg} alt='delete' onClick={() => handleDeleteBrand(brand.id)} />
                <img
                  className='ProductsList__icon'
                  src={editImg}
                  alt='edit'
                  onClick={() => {
                    setCurrentForm('brandForm');
                    setCurrentProduct(brand.id);
                  }}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <Pagination
        itemsPerPage={itemsPerPage}
        currentPage={currentPage}
        totalPages={totalPages}
        setCurrentPage={setCurrentPage}
        count={count}
      />
    </div>
  );
};

export default BrandList;
